import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const removeAssessmentFromReturn = {
  name: "removeAssessmentFromReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    productId: z.string(),
    definitionId: zExt.objectId(),
  }),
  output: z.object({ success: z.boolean() }),
};
